import { cx } from '@linaria/core';
import { useRef } from 'react';
import { avoidBreakSnapPoint, avoidBreakInside } from '@provider/print';
import { useKatex } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useTaskContext } from '../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { tileSelectors, content as content$1 } from './_tile-input.style.js';
import { TileMoveIcon } from './atom.move-icon.js';
import { StateIcon } from './atom.state-icon.js';
import { audioPlayer, audioTitle, content, audio } from './tile.audio.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function AudioTile(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const ref = useRef(null);
  useKatex(ref);
  return /*#__PURE__*/jsxs("div", {
    className: cx(content$1, audio, props.className),
    "data-id": props.id,
    "data-type": "audio",
    "data-state": props.state,
    "data-flow": props.preferredFlow,
    "data-size": props.size,
    "data-theme": props.facitTheme,
    "data-context": context,
    "data-page-context": pageContext,
    "data-is-draggable": props.isDraggable,
    "data-is-overlay": props.isDragOverlay,
    ...avoidBreakInside({
      extend: {
        bottom: 10,
        top: 18
      }
    }),
    ...avoidBreakSnapPoint(),
    children: [/*#__PURE__*/jsxs("div", {
      className: cx(content, tileSelectors.content.className),
      children: [/*#__PURE__*/jsx(CircledAudioPlayer, {
        className: audioPlayer,
        src: props.src,
        size: props.title.trim() && (isMobile || props.size === "thin" || props.preferredFlow === "row") ? "small" : undefined,
        disabled: props.isDragOverlay
      }), props.title.trim() && /*#__PURE__*/jsx("span", {
        ref: ref,
        className: audioTitle,
        children: props.title
      })]
    }), /*#__PURE__*/jsx(TileMoveIcon, {
      ...props
    }), /*#__PURE__*/jsx(StateIcon, {
      ...props
    })]
  });
}

export { AudioTile };
//# sourceMappingURL=tile.audio.js.map
